<div id="header.profile-dropdown" class="dropdown-wrapper">
  <div #header class="dropdown-header-wrapper">
    <ng-content select="[header]"></ng-content>
  </div>
  <div id="header.logout-button" class="dropdown-body-wrapper" data-cy="dropdown-body-wrapper" [ngClass]="{'dropdown-body-wrapper--left': alignLeft, 'dropdown-body-wrapper--right': !alignLeft}">
    @if (showDropdown) {
      <ng-content select="[body]"></ng-content>
    }
  </div>
</div>
